// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const FileDocumentIcon: Icon = ({ size = 32, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="file document"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M19.9993 30.3332H11.9993C4.75935 30.3332 1.66602 27.2398 1.66602 19.9998V11.9998C1.66602 4.75984 4.75935 1.6665 11.9993 1.6665H18.666C19.2127 1.6665 19.666 2.11984 19.666 2.6665C19.666 3.21317 19.2127 3.6665 18.666 3.6665H11.9993C5.85268 3.6665 3.66602 5.85317 3.66602 11.9998V19.9998C3.66602 26.1465 5.85268 28.3332 11.9993 28.3332H19.9993C26.146 28.3332 28.3327 26.1465 28.3327 19.9998V13.3332C28.3327 12.7865 28.786 12.3332 29.3327 12.3332C29.8794 12.3332 30.3327 12.7865 30.3327 13.3332V19.9998C30.3327 27.2398 27.2393 30.3332 19.9993 30.3332Z" fill={fill} />
      <path d="M29.3327 14.3337H23.9993C19.4393 14.3337 17.666 12.5603 17.666 8.00031V2.66698C17.666 2.26698 17.906 1.89364 18.2793 1.74698C18.6527 1.58698 19.0793 1.68031 19.3727 1.96031L30.0394 12.627C30.3194 12.907 30.4127 13.347 30.2527 13.7203C30.0927 14.0937 29.7327 14.3337 29.3327 14.3337ZM19.666 5.08031V8.00031C19.666 11.4403 20.5593 12.3336 23.9993 12.3336H26.9193L19.666 5.08031Z" fill={fill} />
    </svg>
  );
};

export { FileDocumentIcon };
